import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>News & Updates</h1>
                <p>Home &gt; News & Updates</p>
            </div>
        </div>
    )
}

export default Hero;